


















































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import Navigation from "@/components/Navigation.vue";
import { Action, Getter } from "vuex-class";
import requestService from "@/service/requestService";

@Component({
  components: {
    Header,
    SubHeader
  }
})
export default class AdditionalMaintenance extends Vue {
  @Getter("inspectTime", { namespace: "SubHeader" })
  inspectionTime: number;
  @Getter("maintenanceTime", { namespace: "SubHeader" })
  maintenanceTime: number;
  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;

  @Action("restoreState", { namespace: "ReservationDetail" })
  restoreState: any;

  created() {
    
    this.restoreState();
    const data = {
      screenCd: "MD0012",
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      currentWorkProgressState: this.stateId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };

    let reqService = new requestService();
    reqService.updateWorkProgressState(data);
  }

  onNext() {
    this.$router.push({ name: "completed" });
  }
}
